import { render, staticRenderFns } from "./YzDatabinSync.vue?vue&type=template&id=5974956c&scoped=true&lang=pug&"
import script from "./YzDatabinSync.vue?vue&type=script&lang=js&"
export * from "./YzDatabinSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5974956c",
  null
  
)

export default component.exports